export enum HooRequestStatusEnum {
  PENDING = 'Pending',
  CANCELED = 'Canceled',
  REJECTED = 'Rejected',
  APPROVED = 'Approved',
  COMPLETED = 'Completed',
}
